import React from 'react';
import { graphql } from 'gatsby';
import { Html as HtmlComponent } from '@zempler/theme/src/components/html/Html';
import { formatForID } from '@zempler/theme/src/utils';

export const Html = ({ data: { content, idName, useCustomBulletPoints }, ...rest }) => (
  <HtmlComponent {...rest} id={idName ? formatForID(idName) : ''} useCustomBulletPoints={useCustomBulletPoints}>
    {content}
  </HtmlComponent>
);

export const HtmlQuery = graphql`
  fragment Html on UMBRACO_HtmlComponentType {
    content
    idName
    useCustomBulletPoints
  }
`;
